import { store } from "infrastructure/store/ConfigureStore";
import { EnabledRequirementType } from "features/requirements/enums/enabledRequirementType";

export const isEnabledCustomForm = (type: EnabledRequirementType): boolean => {
  const configuredTypes = store.getState().requirementTypes.requiremntTypes;
  const typeToCheck = configuredTypes.find(x => x.code === type);

  return typeToCheck?.enabledCustomForm === true;
}

export const containsRequirementType = (type: string): boolean => {
  const configuredTypes = store.getState().requirementTypes.requiremntTypes;
  const typeToCheck = configuredTypes.find(x => x.code === type);

  return typeToCheck !== undefined;
}